
import React from 'react';
import StudentCornor from 'views/StoryTelling';

const StudentCornorPage = () => {
  return <StudentCornor />;
};

export default StudentCornorPage;